import { z } from 'zod';

export const detailsSchema = z.object({
  name: z.string().trim().min(1, 'REQUIRED'),
  email: z.string().trim().email('INVALID EMAIL'),
  phone: z.string().trim().optional().default(''),
});

export const paymentSchema = z.object({
  card: z.string().trim().min(12, 'INVALID').max(23, 'INVALID'),
  exp: z
    .string()
    .trim()
    .regex(/^\d{2}\s*\/\s*\d{2}$/, 'MM / YY'),
  cvc: z
    .string()
    .trim()
    .regex(/^\d{3,4}$/, '3–4 DIGITS'),
});

export type DetailsValues = z.infer<typeof detailsSchema>;
export type PaymentValues = z.infer<typeof paymentSchema>;
